import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import FormControl from 'react-bootstrap/FormControl';
import { timeToInt, timeFromInt } from 'time-number';

function TimePicker(_ref) {
  var _ref$end = _ref.end,
      end = _ref$end === void 0 ? '23:59' : _ref$end,
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? 12 : _ref$format,
      _ref$initialValue = _ref.initialValue,
      initialValue = _ref$initialValue === void 0 ? '00:00' : _ref$initialValue,
      _ref$onChange = _ref.onChange,
      _onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$start = _ref.start,
      start = _ref$start === void 0 ? '00:00' : _ref$start,
      _ref$step = _ref.step,
      step = _ref$step === void 0 ? 30 : _ref$step,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? null : _ref$value,
      _ref$exclude = _ref.exclude,
      exclude = _ref$exclude === void 0 ? [] : _ref$exclude,
      rest = _objectWithoutProperties(_ref, ["end", "format", "initialValue", "onChange", "start", "step", "value", "exclude"]);

  function generateFormattedTime(time) {
    var ret = timeFromInt(time, false);

    if (format === 24) {
      return ret;
    }

    var found = ret.match(/^(\d+):/);
    var hour = parseInt(found[1], 10);

    if (hour === 0) {
      return "".concat(ret.replace(/^\d+/, '12'), " AM");
    }

    if (hour < 12) {
      return "".concat(ret, " AM");
    }

    if (hour === 12) {
      return "".concat(ret, " PM");
    }

    var newHour = hour < 22 ? "0".concat(hour - 12) : (hour - 12).toString();
    return "".concat(ret.replace(/^\d+/, newHour), " PM");
  }

  function generateTimeRange() {
    var times = [];
    var iend = timeToInt(end, false);

    for (var i = timeToInt(start, false); i <= iend; i += step * 60) {
      times.push(i);
    }

    return times;
  }

  function listTimeOptions() {
    return generateTimeRange().map(function (unformattedTime) {
      var formattedTime = generateFormattedTime(unformattedTime);
      return {
        key: unformattedTime,
        val: formattedTime,
        disabled: !(exclude.indexOf(formattedTime) === -1)
      };
    });
  }

  var timeOptions = listTimeOptions();
  var optionWidgets = timeOptions.map(function (_ref2) {
    var key = _ref2.key,
        val = _ref2.val,
        disabled = _ref2.disabled;
    return /*#__PURE__*/React.createElement("option", {
      key: key,
      value: key,
      disabled: disabled
    }, val);
  });
  var currentValue = value || initialValue;

  try {
    currentValue = timeToInt(currentValue);
  } catch (ex) {
    currentValue = parseInt(currentValue, 10);
  }

  if (!timeOptions.filter(function (_ref3) {
    var key = _ref3.key;
    return currentValue === key;
  }).length) {
    currentValue = timeToInt(start);
  }

  return /*#__PURE__*/React.createElement(FormControl, _extends({
    as: "select",
    onChange: function onChange(e) {
      _onChange(parseInt(e.target.value, 10));
    },
    value: currentValue
  }, rest), optionWidgets);
}

export default TimePicker;